import styled from "styled-components";

interface TabIdentifierProps {
  active: boolean;
}

const Container = styled.div`
  padding: 0 30px 50px 30px;
  display: flex;
  flex-direction: column;

  > :not(:last-child) {
    margin-bottom: 20px;
  }
`;

const TabsContainer = styled.div`
  display: flex;
  gap: 25px;
`;

const TabButton = styled.button`
  font-size: 18px;
  cursor: pointer;
  border: none;
  background-color: transparent;
  position: relative;
`;

const TabIdentifier = styled.i<TabIdentifierProps>`
  position: absolute;
  width: 100%;
  height: 4px;
  border-radius: 10px;
  transition: all 0.5s ease-in-out;
  background-color: ${({ theme }) => theme.colors.tertiary};
  display: ${(props) => (props.active ? "block" : "none")};
`;

export {
  Container,
  TabsContainer,
  TabButton,
  TabIdentifier
};
